import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import api from '../api';

const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const now = new Date();

export default function Maintenance() {
  const [records, setRecords] = useState([]);
  const [filterMonth, setFilterMonth] = useState(now.getMonth() + 1);
  const [filterYear, setFilterYear] = useState(now.getFullYear());
  const [filterStatus, setFilterStatus] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ issue: '', description: '', cost: '', date: now.toISOString().split('T')[0], status: 'Pending' });
  const [msg, setMsg] = useState('');

  const load = () =>
    api.get('/maintenance', { params: { month: filterMonth, year: filterYear, status: filterStatus || undefined } })
      .then(r => setRecords(r.data));

  useEffect(() => { load(); }, [filterMonth, filterYear, filterStatus]);

  const openAdd = () => { setForm({ issue: '', description: '', cost: '', date: now.toISOString().split('T')[0], status: 'Pending' }); setEditItem(null); setShowModal(true); };
  const openEdit = (rec) => { setForm({ issue: rec.issue, description: rec.description || '', cost: rec.cost || '', date: rec.date?.split('T')[0] || '', status: rec.status }); setEditItem(rec._id); setShowModal(true); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editItem) await api.put(`/maintenance/${editItem}`, form);
      else await api.post('/maintenance', form);
      setShowModal(false);
      setMsg(editItem ? 'Record updated!' : 'Record added!');
      load();
    } catch (err) { setMsg(err.response?.data?.message || 'Error'); }
  };

  const deleteRec = async (id) => {
    if (!window.confirm('Delete this maintenance record?')) return;
    await api.delete(`/maintenance/${id}`);
    load();
  };

  const totalCost = records.reduce((s, r) => s + (r.cost || 0), 0);
  const pending = records.filter(r => r.status === 'Pending').length;

  return (
    <Layout title="Maintenance">
      {msg && <div className="alert alert-info">{msg} <button style={{ float:'right', background:'none', border:'none', cursor:'pointer' }} onClick={() => setMsg('')}>✕</button></div>}

      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(3,1fr)', maxWidth: 500 }}>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#3182ce', color: '#fff' }}>🔧</div>
          <div className="stat-info"><h3>{records.length}</h3><p>Total Issues</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#e53e3e', color: '#fff' }}>⏳</div>
          <div className="stat-info"><h3>{pending}</h3><p>Pending</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#d69e2e', color: '#fff' }}>💸</div>
          <div className="stat-info"><h3 style={{ fontSize: 16 }}>PKR {totalCost.toLocaleString()}</h3><p>Total Cost</p></div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">🔧 Maintenance Records</h3>
          <div className="flex gap-10">
            <select value={filterMonth} onChange={e => setFilterMonth(e.target.value)}>
              {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
            <select value={filterYear} onChange={e => setFilterYear(e.target.value)}>
              {[2024, 2025, 2026, 2027].map(y => <option key={y}>{y}</option>)}
            </select>
            <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
              <option value="">All Status</option>
              <option>Pending</option>
              <option>In Progress</option>
              <option>Completed</option>
            </select>
            <button className="btn btn-primary btn-sm" onClick={openAdd}>➕ Add Issue</button>
          </div>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr><th>Issue</th><th>Description</th><th>Date</th><th>Cost</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {records.length === 0 ? (
                <tr><td colSpan={6} className="text-center" style={{ padding: 30, color: '#718096' }}>No maintenance records</td></tr>
              ) : records.map(r => (
                <tr key={r._id}>
                  <td><strong>{r.issue}</strong></td>
                  <td style={{ fontSize: 12, maxWidth: 200 }}>{r.description || '-'}</td>
                  <td style={{ fontSize: 12 }}>{r.date?.split('T')[0]}</td>
                  <td>PKR {(r.cost || 0).toLocaleString()}</td>
                  <td>
                    <span className={`badge ${r.status === 'Completed' ? 'badge-success' : r.status === 'In Progress' ? 'badge-warning' : 'badge-danger'}`}>
                      {r.status === 'Completed' ? '✅' : r.status === 'In Progress' ? '🔄' : '⏳'} {r.status}
                    </span>
                  </td>
                  <td>
                    <div className="flex gap-10">
                      <button className="btn btn-warning btn-sm" onClick={() => openEdit(r)}>✏️</button>
                      <button className="btn btn-danger btn-sm" onClick={() => deleteRec(r._id)}>🗑</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editItem ? 'Edit Maintenance Record' : 'Add Maintenance Issue'}</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSave}>
                <div className="form-grid">
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label>Issue / Title *</label>
                    <input value={form.issue} onChange={e => setForm(f => ({ ...f, issue: e.target.value }))} required placeholder="e.g. Broken window in Room G3" />
                  </div>
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label>Description</label>
                    <textarea value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="Detailed description of the issue..." rows={3} />
                  </div>
                  <div className="form-group">
                    <label>Repair Cost (PKR)</label>
                    <input type="number" value={form.cost} onChange={e => setForm(f => ({ ...f, cost: e.target.value }))} min="0" placeholder="0" />
                  </div>
                  <div className="form-group">
                    <label>Date *</label>
                    <input type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} required />
                  </div>
                  <div className="form-group">
                    <label>Status</label>
                    <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
                      <option>Pending</option>
                      <option>In Progress</option>
                      <option>Completed</option>
                    </select>
                  </div>
                </div>
                <div className="form-actions">
                  <button type="button" className="btn btn-outline" onClick={() => setShowModal(false)}>Cancel</button>
                  <button type="submit" className="btn btn-primary">💾 Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
